import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import utils from '@/utils/utils';
import dd from '@/utils/dd';
import "./style.scss";

function CustomizeImg(props: any) {
    const { id, data, mark, pId, mallTest } = props;
    const clickCustomizeImg = () => {
        // 点击埋点
        let extendParams = {
            ...dd.ep,
            providerId: pId,
            linkUrl: data.bigPicUrl,
            compId: data.id,
            mallTest
        };
        extendParams = utils.formatParams(extendParams);
        utils.pvTrackLogger(
            'click',
            'ec_topic_mall_zdytupian_click',
            dd.baseParams,
            extendParams
        );

    };

    useEffect(() => {
        if (!!data.bigPicData && mark.pageType === "mall") {
          // 曝光埋点
          let extendParams = {
            ...dd.ep,
            providerId: pId,
            linkUrl: data.bigPicUrl,
            compId: data.id,
            mallTest,
          };
          extendParams = utils.formatParams(extendParams);
          utils.pvTrackLogger(
            "show",
            "ec_topic_mall_zdytupian_show",
            dd.baseParams,
            extendParams
          );
        }
    }, [JSON.stringify(data), JSON.stringify(mark)]);

    return (
        <div
            key={id}
            className='tabHome-item zdy'
            dangerouslySetInnerHTML = {{ __html: data.bigPicData }}
            onClick={() => clickCustomizeImg()}
        />
        // 图片锚点定位
        // <div key={v.sort} className='tabHome-item'>
        //     <img
        //         // src={v.bigPicData.picture}
        //         src={backdrop}
        //         style={{
        //             width: '100%',
        //             // height: Number(v.siteUserBanner.height)
        //             height: 300
        //         }}
        //         useMap='#Map'
        //     />
        //     <map name="Map" id="Map">
        //         <area shape="rect" coords="12,37,181,88" href="http://www.qq.com"/>
        //         <area shape="rect" coords="12,97,182,143" href="http://www.yahoo.com" />
        //         <area shape="rect" coords="18,155,179,200" href="http://www.sina.com" />
        //         <area shape="rect" coords="18,211,182,260" href="http://www.baidu.com" />
        //     </map>
        // </div>
    );
}

export default CustomizeImg;
